import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map, Observable } from 'rxjs';
import { ApiwrapperService } from 'src/app/services/apiwrapper.service';

interface SortingByScore {
  name: string,
  slug: string,
  value: string
}

@Component({
  selector: 'app-drill-down',
  templateUrl: './drill-down.component.html',
  styleUrls: ['./drill-down.component.scss']
})
export class DrillDownComponent implements OnInit {
  @Input() projectUuid!: string;
  @Input() set categories(value: any) {
    if (value.categoriesList?.length) {
      this.activeCategory = value.activeCategory;
      this.categoryList = value.categoriesList;
      this.pageOfCurrentCategory = value.categoriesList.findIndex((item: any) => item.uuid === value.activeCategory);
      this.cd.detectChanges();
    }
  };

  @Input() set statements(value: any) {
    if (value) {
      this.statementData = value;
    }
  }
  @Input() intervals!: any[];

  @ViewChild('carousel') carousel: any;

  statementData: any;
  activeCategory: any;
  previousShowSelectedTabStateIndex: any;
  responseDistribution: any;
  activeSorting: any;
  
  showCarousel: boolean = false;
  
  pageOfCurrentCategory!: number;
  activePage: number = 0;

  categoryList: any[] = [];
  showSelectedTabState: any[] = [];
  sortingByIndicators: SortingByScore[] = [
    {name: this.translate.instant('drill_down_sort_by_latest'), slug: 'latest', value: ''},
    {name: this.translate.instant('drill_down_sort_by_highest'), slug: 'highest', value: 'DESC'},
    {name: this.translate.instant('drill_down_sort_by_lowest'), slug: 'lowest', value: 'ASC'}
  ];

  constructor(
    private translate: TranslateService,
    private cd: ChangeDetectorRef,
    private api: ApiwrapperService,
  ) {}

  ngOnInit(): void {
    this.activeSorting = this.sortingByIndicators[0];
  }
  changeSorting() {
    this.activePage = 0;
    this.getCategoryStatements(this.activeCategory, 1);
  }

  changeCategoryPage(event: any) {
    this.showSelectedTabState = this.showSelectedTabState.map(() => false);
    this.pageOfCurrentCategory = event.page;
    this.activePage = 0;
    this.activeCategory = this.categoryList[event.page].uuid;
    this.getCategoryStatements(this.activeCategory, 1);
  }

  changeStatementsPage(event: any) {
    this.activePage = event.page;
    this.showSelectedTabState = this.showSelectedTabState.map(() => false);
    this.getCategoryStatements(this.activeCategory, event.page + 1);
  }

  emitStatementResponses(statementType: any, statementCheckin: any, statementUuid: any, index: number) {
    this.showSelectedTabState = this.showSelectedTabState.map(() => false);
    this.showSelectedTabState[index] = true;
    if (statementType !== 'ranked') {
      this.api.getProjectTeamCollectionQuestionResponses(statementUuid, this.projectUuid, statementType, 1, 6).subscribe((res: any) => {
        if (res && statementType === 'scaled') {
          this.getQuestionDistributionValues(res, statementCheckin);
        }
      });
    }
  }

  getQuestionDistributionValues(value: any, statementCheckin: any) {
    if (value) {
      value.checkinData = statementCheckin;
      value.onInsight = true;
      value.onDrillDown = true;
      value.eligibleForResult = true;
      this.responseDistribution = new Observable(subcriber => {
        subcriber.next(value);
      });
    }
    this.cd.detectChanges();
  }

  getCategoryStatements(categoryUuid: string, page: number) {
    let limit = 4;
    if (window.matchMedia('(min-width: 1920px)').matches) {
      limit = 8;
    } else if (window.matchMedia('(min-width: 1600px)').matches) {
      limit = 6;
    }
    const filters = {page: page, limit: limit, score: this.activeSorting.value};
    
    this.api.getCategoryDrillDownStatements(this.projectUuid, categoryUuid, filters).pipe(
      map((res: any) => {
        const statements = (res._embedded.project ?? []).map((statement: any) => {
          const matchedInterval = this.intervals.find(interval =>
            interval.min <= statement.score &&
            statement.score <= interval.max
          );
          
          return {
            ...statement,
            question: {
              ...statement.question,
              color: matchedInterval ? matchedInterval.indicatorColor.color : 'default',
              rating: Math.round(statement.score / 10),
            }
          };
        });

        return {
          statements,
          currentPage: res._page,
          pageCount: res._page_count,
          totalItems: res._total_items
        };
      })
    ).subscribe((res: any) => {
      this.statementData.statements = res.statements;
      this.cd.detectChanges();
    });
  }

  nextCarouselPage() {
    this.carousel.navForward();
  }

  prevCarouselPage() {
    this.carousel.navBackward();
  }
}
